import { render, staticRenderFns } from "./UiInput.vue?vue&type=template&id=bcbba7e2"
import script from "./UiInput.vue?vue&type=script&lang=js"
export * from "./UiInput.vue?vue&type=script&lang=js"
import style0 from "./UiInput.vue?vue&type=style&index=0&id=bcbba7e2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports